import api from "./api";

const FileManagerAPI = {
    getAll: () => api.get("/admin/file-manager/all"),
    uploadFile: (file) => api.post("/admin/file-manager/upload", file),
    deleteFile: (fileNames) => api.post(`/admin/file-manager/delete-multiple`, fileNames),
    renameFile: (data) => api.post("/admin/file-manager/rename", data),
};

export default FileManagerAPI;
